import React, { FC, useCallback } from 'react';

/**
 * A link inside a sentence, which always opens a new tab.
 *
 * `showExternalIcon` adds the trailing mark `HyperLink` draws, for the places
 * that say so in the design. It is opt-in rather than always on because this
 * component is already in use without it, and turning it on everywhere would
 * change those lines rather than this one.
 */
const InlineHyperlink: FC<any> = ({ path, text, showExternalIcon = false }) => {
	const onLinkClick = useCallback(() => window.open(path, '_blank', 'noreferrer'), [path]);

	return (
		<span
			className="cursor-pointer whitespace-nowrap text-blue-600 underline hover:text-blue-800"
			onClick={onLinkClick}
		>
			{text}
			{showExternalIcon ? (
				<span className="relative bottom-[0.5px] ml-1">
					<i className="icons8-font icons8-external-link" />
				</span>
			) : null}
		</span>
	);
};

export default InlineHyperlink;
